import script from "./UsersGroupsView.vue?vue&type=script&setup=true&lang=js"
export * from "./UsersGroupsView.vue?vue&type=script&setup=true&lang=js"

import "./UsersGroupsView.vue?vue&type=style&index=0&id=4f7b35a2&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4f7b35a2"]])

export default __exports__